import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

const Modal = ({
  children = null, isShowing = false, onHide = null, className = '',
}) => {
  const modalRef = useRef(null);
  const mouseDownOnBackdrop = useRef(false);
  const [isVisible, setIsVisible] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false);

  // eslint-disable-next-line consistent-return
  useEffect(() => {
    if (isShowing) {
      setIsVisible(true);
      setTimeout(() => setIsAnimating(true), 10);
    } else {
      setIsAnimating(false);
      const timeoutId = setTimeout(() => setIsVisible(false), 300);
      return () => clearTimeout(timeoutId);
    }
  }, [isShowing]);

  useEffect(() => {
    if (isVisible) {
      modalRef.current?.focus();
    }
  }, [isVisible]);

  const handleBackdropMouseDown = (e) => {
    mouseDownOnBackdrop.current = e.target === e.currentTarget;
  };

  const handleBackdropClick = (e) => {
    if (mouseDownOnBackdrop.current && e.target === e.currentTarget) {
      onHide();
    }
    mouseDownOnBackdrop.current = false;
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Escape') {
      onHide();
    }
  };

  if (!isVisible) {
    return null;
  }

  return (
    // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
    <div
      className={`fixed inset-0  bg-modal-background z-50 flex justify-center items-center transition-opacity duration-500 ${isAnimating ? 'opacity-100' : 'opacity-0'}`}
      onMouseDown={handleBackdropMouseDown}
      onClick={handleBackdropClick}
      onKeyDown={handleKeyDown}
      tabIndex="-1"
      role="dialog"
      aria-modal="true"
      ref={modalRef}
    >
      <div
        className={`transition-transform duration-500 transform ${isAnimating ? 'translate-y-0' : '-translate-y-10'} ${className}`}
        onClick={(e) => e.stopPropagation()}
        role="presentation"
      >
        {children}
      </div>
    </div>
  );
};

Modal.propTypes = {
  children: PropTypes.node,
  isShowing: PropTypes.bool,
  onHide: PropTypes.func,
  className: PropTypes.string,
};

export default Modal;
